<ng-container *ngIf="viewModel$ | async as viewModel">
  <div class="address-with-unit-container">
    <div class="unit">
      <label for="unitNumber">
        Unit #
      </label>
      <div class="p-inputgroup mt-05">
        <input
          #unitNumber
          type="text"
          pInputText
          [ngModel]="viewModel.location?.unitNumber"
          [style]="{ 'marginTop': '0.5rem' }"
          (ngModelChange)="store.dispatch(actions.unitNumberEntered({
            locationType: locationType,
            unitNumber: $event
          }))"
          class="no-min-width"
        />
      </div>
    </div>
    <div class="address">
      <label for="#address">Address</label>
      <div class="p-inputgroup">
        <input
          #address
          *ngIf="googleHelper.loaded | async"
          [ngModel]="viewModel.location?.address"
          #googleAutocomplete="ngx-places"
          ngx-gp-autocomplete
          pInputText
          autocomplete="off"
          (onAddressChange)="store.dispatch(actions.googleAutocompleteAddressSelected({
            address: $event,
            locationType: locationType
          }))"
          (input)="store.dispatch(actions.googleAutocompleteInputChanged({
            address: $event.target.value,
            locationType: locationType
          }))"
          [inputStyle]="{ width: '100%' }"
          [ngClass]="{
            'ng-invalid': viewModel.locationInvalid
          }"
        />
        <button
          type="button"
          pButton
          pRipple
          (click)="store.dispatch(actions.addLocationManuallyButtonClicked({
              locationType: locationType
          }))"
          icon="pi pi-map-marker"
          class="p-button-secondary p-button-outlined"
          pTooltip="Add a location without using the autocomplete"
        ></button>
      </div>
      <small *ngIf="viewModel.locationInvalid">
      You must use autocomplete to set the location.
      </small>
    </div>
  </div>
</ng-container>
